<div class="card dialog-box">
  <div class="card-header">
    <span class="float-end" (click)="onCloseDialog(false)">
      <i class="fa-solid fa-xmark"></i>
    </span>
  </div>
  <div>
    <div class="mb-3">
      <button class="btn" (click)="configureCheckpointScanMenu()">
        <div class="d-flex align-items-center gap-2">
          <i class="fa-solid fa-cog fs-6"></i>
          Configure
        </div>
      </button>
    </div>
    <div class="d-flex flex-column justify-content-between gap-5">
      @if (showNormalScanBtn) {
        <div
          id="scanCheckpoint"
          class="d-flex p-4 flex-column align-items-center justify-content-center w-100 bg-success-subtle text-success-emphasis text-center rounded border border-success"
          (click)="onCloseDialog({ source: 'scanCheckPoint' })"
        >
          <div class="p-2">
            <i class="fa-solid fa-circle-check fa-3x text-dark"></i>
          </div>
          <div>Scan Checkpoint Near You</div>
        </div>
      }

      @if (showNFCScanBtn) {
        <div
          id="scanNFCButton"
          class="d-flex p-4 flex-column align-items-center justify-content-center w-100 bg-primary-subtle text-primary-emphasis text-center rounded border border-primary"
          (click)="readNFC()"
        >
          <div class="bg-light p-1 rounded">
            <img
              src="assets/images/NFC_logo.avif"
              alt=""
              srcset=""
              width="40"
            />
          </div>
          <div>Scan NFC Tag</div>
        </div>
      }
      @if (showQRScanBtn) {
        <div
          id="scanQRButton"
          class="d-flex p-4 flex-column align-items-center justify-content-center w-100 bg-warning-subtle text-warning-emphasis rounded border border-secondary"
          [class.disabled]="!cameraOnDevice"
          (click)="openQRCode()"
          [style.pointer-events]="!cameraOnDevice ? 'none' : 'auto'"
          [style.opacity]="!cameraOnDevice ? 0.5 : 1"
        >
          <div class="p-1 bg-white">
            <img
              src="assets/images/qr-code-logo.avif"
              alt=""
              srcset=""
              width="40"
            />
          </div>
          <div>Scan QR Code</div>
        </div>
      }
    </div>
  </div>
</div>

<ng-template
  #nfcPermissionTempateRef
  let-data
  let-nfcPermissionTempateRef="dialogRef"
>
  <div class="dialog-box card p-2">
    <div class="card-header">
      NFC Access
      <!-- <span class="float-end" (click)="missedEventReasonTemplateRef.close()">
                      <i class="fa-solid fa-xmark"></i>
                    </span> -->
    </div>
    <div class="text-center my-5 d-flex justify-content-center">
      <div class="bg-white p-3 rounded">
        <!-- <i class="fa-brands fa-nfc-symbol fa-3x"></i> -->
        <img
          src="assets/images/NFC_logo.avif"
          alt=""
          srcset=""
          width="64"
          height="64"
        />
      </div>
    </div>
    @switch (nfcStateStatus) {
      @case ("prompt") {
        <div class="text-center mb-5">
          <div class="mb-5">Guard Tracker needs NFC enabled to scan.</div>
          <div>
            When prompted, please tap
            <span class="fw-semibold text-danger">Allow</span> on your phone.
          </div>
        </div>
        <div>
          <button
            type="button"
            class="btn btn-outline-primary btn-lg w-100"
            (click)="checkNfcPermission()"
          >
            Continue
          </button>
        </div>
      }
      @case ("denied") {
        <div class="mb-5 text-center text-danger">
          <div class="mb-4">Guard Tracker needs NFC enabled to scan.</div>
          <div>Allow access and try again.</div>
        </div>
        @if (isNativeApp) {
          <div (click)="nfcPermissionTempateRef.close(false); openSettings()">
            <button type="button" class="btn btn-secondary btn-lg w-100">
              Open settings
            </button>
          </div>
        } @else {
          <div (click)="nfcPermissionTempateRef.close(false)">
            <button type="button" class="btn btn-secondary btn-lg w-100">
              Back
            </button>
          </div>
        }
      }
      @case ("restricted") {
        <div class="mb-5 text-center text-danger">
          <div class="mb-4">Something went wrong.</div>
          <div>WebNFC may not be available on this browser.</div>
        </div>
        <div (click)="nfcPermissionTempateRef.close(false)">
          <button type="button" class="btn btn-secondary btn-lg w-100">
            Back
          </button>
        </div>
      }
    }
  </div>
</ng-template>
